export default __webpack_public_path__ + "static/media/app-screens-v2-67-2_08.8159ffa6.jpg";